import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import * as GSAP from 'gsap'

// Textures
const textureLoader = new THREE.TextureLoader()
const shadowTexture = textureLoader.load('./textures/shadow.jpg')

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color(0x5a7aa1)

// Animation mixer
let mixer = new THREE.AnimationMixer()

// glTF loader and (drone) model
const loader = new GLTFLoader()
let drone = null
loader.load('./models/drone-animation.glb', (gltf) => {
    drone = gltf.scene
    scene.add(drone)

    mixer = new THREE.AnimationMixer(drone)
    const clips = gltf.animations;

    clips.forEach((clip) => {
        let action = mixer.clipAction(clip)
        action.play()
    })
},
    function (xhr) {
        console.log('Loading: ' + (xhr.loaded / xhr.total * 100) + '% loaded')
    },
    function (error) {
        console.log('An error occurred')
    })

// Ground plane
const ground = new THREE.Mesh(
    new THREE.PlaneBufferGeometry(2, 2),
    new THREE.MeshBasicMaterial({ color: 0xcccccc })
)
ground.rotation.x = - Math.PI * 0.5
scene.add(ground)

// Drone shadow
const droneShadow = new THREE.Mesh(
    new THREE.PlaneGeometry(1, 1),
    new THREE.MeshBasicMaterial({
        color: 0x000000,
        transparent: true,
        alphaMap: shadowTexture
    })
)
droneShadow.rotation.x = - Math.PI * 0.5
droneShadow.position.y = ground.position.y + 0.01
scene.add(droneShadow)

// Lights
const ambientLight = new THREE.AmbientLight(0xffffff, 1)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xaaaaaa, 10.0)
directionalLight.position.set(5, 10, 0)
scene.add(directionalLight)

const hemisphereLight = new THREE.HemisphereLight(0xff0000, 0x0000ff, 1.0)
scene.add(hemisphereLight)

// Viewport dimensions
const dimensions = {
    width: window.innerWidth,
    height: window.innerHeight
}

// Events
window.addEventListener('resize', () => {
    // Update sizes
    dimensions.width = window.innerWidth
    dimensions.height = window.innerHeight

    // Update camera
    camera.aspect = dimensions.width / dimensions.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(dimensions.width, dimensions.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

window.addEventListener('dblclick', () => {
    const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement

    if (!fullscreenElement) {
        if (canvas.requestFullscreen) {
            canvas.requestFullscreen()
        }
        else if (canvas.webkitRequestFullscreen) {
            canvas.webkitRequestFullscreen()
        }
    }
    else {
        if (document.exitFullscreen) {
            document.exitFullscreen()
        }
        else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen()
        }
    }
})

// Camera
const camera = new THREE.PerspectiveCamera(45, dimensions.width / dimensions.height, 0.05, 10)
camera.position.set(1, 1, 2)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

// Renderer
const renderer = new THREE.WebGLRenderer({
    antialias: true,
    canvas: canvas
})
renderer.setSize(dimensions.width, dimensions.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// Animations
let executed = false
let time = Date.now()

const tick = () => {
    // Time
    const currentTime = Date.now()
    const deltaTime = currentTime - time
    time = currentTime

    // Update the drone and its shadow
    if (drone) {
        if (!executed) {
            const timeline = new GSAP.TimelineMax({ repeat: -1, yoyo: true })
            timeline
                .to(drone.position, { y: 0 })
                .to(drone.position, { duration: 3.5, ease: GSAP.Power2.easeInOut, y: 0.75 })

            executed = true
        }
        droneShadow.material.opacity = (1 - (drone.position.y + 0.2)) * 0.45
    }

    // Update controls
    controls.update()

    // Update animation mixer
    mixer.update(deltaTime)

    // Render
    renderer.render(scene, camera)

    // Call tick (function) again on the next frame
    window.requestAnimationFrame(tick)
}

tick()